import React, { useState, useEffect } from "react";
import CommodityModal from "./CommodityModal";
import { motion } from "framer-motion";
import {
  Plus,
  Building2,
  FileText,
  Package,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import {
  getCommodityList,
  createCommodity,
  UpdateCommodity,
  DeleteCommodity,
} from "@/redux/Masters/commodity/actions";

import { callLoader } from "@/redux/Loader/actions";
import { validateForm } from "../ui/useFormValidation";
import { showToast } from "@/redux/Toast/actions";
import { getCommodityColumns } from "./helper";
import { DataTable } from "../ui/table";
import Pagination from "@/pages/PortPlace/Pagination";
import Swal from "sweetalert2";

// const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const MaintainCommodity = () => {
  //    const [bookingData, setBookingData] = useState(initialBookingData);

  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const dispatch = useDispatch();
  const [searchField, setSearchField] = useState("ALL");
  const [recordsPerPage, setRecordPerPage] = useState(10);
  const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];

  const initialCommodityForm = {
    id: "0",
    // vesselName: "",
    // carrier: "",
    // imoCode: "",
    // callSign: "",
    // flag: "",
    // operatorId: "",
    // countryId: "",
    // isActive: true
    flashPointType: "0",
    createdBy: authUser.id,
    modifyBy: authUser.id,
    countryId: authUser.companyId,
  };

  const [dateErrors, setDateErrors] = useState({});
  // TEMP (replace with real ones later)
  const [formData, setFormData] = useState(initialCommodityForm);
  const [errors, setErrors] = useState({});

  const [searchText, setSearchText] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("");

  const { commodityList, pagination } = useSelector((state) => state.commodity);


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
 
  };

  const handleDateError = (fieldName, hasError) => {
    setDateErrors((prev) => ({
      ...prev,
      [fieldName]: hasError,
    }));
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value, // YYYY-MM-DD
    }));
  };

  useEffect(() => {
    _getList(1);
  }, [searchText, recordsPerPage, selectedLetter]);

  const handlePrevious = () => {
    if (currentPage > 1) _getList(currentPage - 1);
  };

  const handleNext = () => {
    if (pagination?.nextPage > 0) _getList(pagination.nextPage);
  };
   const handleGoto = (page) => {
    _getList(page);
  };

  const _getList = async (page = 1) => {
    setCurrentPage(page);
    dispatch(callLoader(1)); // optional loader

    try {
      const payload = {
        pageNo: page,
        records: recordsPerPage,
        filterType: "All",
        searchKeyward: searchText,
        //   SalesPersonId: 0,
        //   PrefixLetter:selectedLetter,
        CompanyID: authUser?.companyId,
      };

      await dispatch(getCommodityList(payload));
    } catch (error) {
      console.error("Error fetching address book list:", error);
      dispatch(showToast("Error fetching address book list", "error"));
      // optional: show toast / alert
    } finally {
      dispatch(callLoader(0));
    }
  };
  const [items, setItems] = useState([]);
  const validationConfig = {
    commodity: { required: true, label: "Commodity" },
    scheduleB: { required: true, label: "Schedule B" },
    htsNumber: { required: true, label: "HTS Number" },
    // primaryUom: { required: true, label: "Primary UOM" },

    ...(formData.hazCommodity && {
      unNumber: { required: true, label: "UN Number" },
      commodityClass: { required: true, label: "Commodity Class" },
    }),
  };

  //-- Form Click Events

  const handleAddNew = () => {
    setFormData(initialCommodityForm);
    //setFormData(null);
    setOpenModal(true);
  };

  // Save Handler
  const handleSaveCommodity = async () => {
    // formvalidation setting here

    const validationErrors = validateForm({
      data: formData,
      items,
      rules: validationConfig,
    });
    setErrors(validationErrors || {}) ;

    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    try {
      dispatch(callLoader(1));
      const payload = {
        ...formData,
        hazCommodity: Boolean(formData.hazCommodity),
        ...(formData.hazCommodity
          ? {}
          : {
              unNumber: "",
              commodityClass: "",
              imdgPageNum: "",
              commodityLable: "",
              packageGroup: "",
              dotCode: "",
              flashPoint: "",
              flashPointType: "0",
            }),
      };

      if (Number(formData.id) === 0) {
        const addDetails = await createCommodity(payload);
        if (addDetails?.statuscode === 201 || addDetails?.statuscode === 200) {
          // setBookingData(addDetails?.addressBookId);
          //toast.success("Record Save successfully");
          dispatch(showToast("Record Save successfully.", "success", true));
        }

        setTimeout(() => {
          setOpenModal(false);
        }, 500);
      } else {
        const addDetails = await UpdateCommodity(payload);
        if (addDetails?.statuscode === 201 || addDetails?.statuscode === 200) {
          // setBookingData(addDetails?.addressBookId);
          //toast.success("Record Update successfully");
          dispatch(showToast("Record Update successfully.", "success", true));
        }
        setTimeout(() => {
          setOpenModal(false);
        }, 500);
      }
      _getList(currentPage); // refresh table
    } catch (err) {
      // toast.error("Failed to save Commodity");
      dispatch(showToast("Failed to save Commodity", "error"));
    } finally {
      dispatch(callLoader(0));
    }
  };

  // Edit Detail
  const handleEdit = (row) => {
    console.log("Row data:", row);
    setFormData({
      ...row,
      flashPointType: row.flashPointType?.toString() ?? "0",
      hazCommodity: Boolean(row.hazCommodity),
      id: Number(row.id || 0),
      modifyBy: authUser.id,
    });
    setOpenModal(true);
  };

  const handleDelete = async (payload) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This record will be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    });

    if (!result.isConfirmed) return;

    //   const finalPayload = {
    //  ...payload,
    //   modifyBy:authUser.id,
    // };

    const finalPayload = {
      id: Number(payload.id),
      modifyBy: authUser.id,
    };
    const updateDetails = await DeleteCommodity(finalPayload);
    if (
      updateDetails?.statuscode === 201 ||
      updateDetails?.statuscode === 200
    ) {
      // toast.success("Record delete successfully");
      dispatch(showToast("Record delete successfully.", "success"));
      _getList(1);
    }
    _getList(1);
  };

  const handlers = {
    handleEdit,
    handleDelete,
  };

  const columns = getCommodityColumns(handlers);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="p-6 space-y-6 pb-12"
    >
      <div className="h-full flex flex-col">
        {/* Header */}
        {/* <div className="flex items-center justify-between mb-4">
                      <div>
                          <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Commodity List</h1>
                          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">{pagination?.totalRecord} Total Commodity</p>
                      </div>
                      <div className="flex items-center space-x-2">
                          <button
                            //   onClick={() => setOpenModal(true)}
                             onClick={() => handleAddNew ()}
                              className="px-5 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-all flex items-center space-x-2"
                          >
                              <Plus className="w-4 h-4" />
                              <span>Add New Commodity</span>
                          </button>
                      </div>
                  </div> */}

        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-cyan-100 dark:bg-cyan-900/30 rounded-xl flex items-center justify-center">
              <Package className="w-6 h-6 text-cyan-600 dark:text-cyan-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-slate-800 dark:text-white">
                Commodity List
              </h1>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                {pagination?.totalRecord} Total Commodity
              </p>
            </div>
          </div>
          <button
            onClick={() => handleAddNew()}
            data-testid="add-clause-btn"
            className="flex items-center gap-2 px-4 py-2.5 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl font-medium transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add New Commodity
          </button>
        </div>

        {/* Search Bar */}
        <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-3 mb-4">
          <div className="flex items-center space-x-2">
            <select
              value={searchField}
              onChange={(e) => setSearchField(e.target.value)}
              className="px-3 py-2 text-sm border-0 bg-slate-50 dark:bg-slate-800 rounded-lg text-slate-900 dark:text-white focus:ring-2 focus:ring-[#0072FF]"
            >
              <option value="ALL">All</option>
              <option value="CID">Commodity ID</option>
              <option selected="selected" value="DES">
                Description
              </option>
              <option value="SCB">Schedule B</option>
            </select>
            <div className="relative flex-1">
              <input
                type="text"
                placeholder="Enter text for search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="w-full px-4 py-2 text-sm border-0 bg-slate-50 dark:bg-slate-800 rounded-lg text-slate-900 dark:text-white placeholder-slate-400 focus:ring-2 focus:ring-[#0072FF] focus:bg-white dark:focus:bg-slate-900 transition-all"
              />
            </div>
            <button className="px-6 py-2 bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all">
              Search
            </button>
          </div>
        </div>

        {/* Table */}

        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
          <DataTable
            data={commodityList || []}
            columns={columns}
            trClass="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-700/30"
            thClass="px-4 py-4 text-left text-xs font-semibold uppercase tracking-wider"
            tdClass="px-4 py-4 text-sm text-slate-600 dark:text-slate-400"
            htrClass="bg-gradient-to-r from-slate-700 to-slate-800 text-white"
            loading={false}
            Icon={Building2}
            emptyText="No Commodity found"
            isAplyingFilter={!!searchText}
            resetFilters={() => {
              setSearchText("");
              setSelectedLetter("ALL");
            }}
          />
        </div>

        {/* Pagination */}
        {commodityList.length > 0 && (
          <Pagination
            currentPage={currentPage}
            nextPage={pagination?.nextPage}
            recordsPerPage={recordsPerPage}
            setRecordsPerPage={setRecordPerPage}
            onPrevious={handlePrevious}
            onNext={handleNext}
              totalRecord={pagination?.totalRecord}
              handleGoto={handleGoto}
          />
        )}
      </div>
      {/* ✅ Modal (CORRECT PLACE) */}
      <CommodityModal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setSelectedVessel(null);
          setFormData(initialCommodityForm);
        }}
        formData={formData}
        errors={errors}
        handleInputChange={handleInputChange}
        handleDateError={handleDateError}
        handleDateChange={handleDateChange}
        onSave={handleSaveCommodity}
        editData={selectedVessel}
      />
    </motion.div>
  );
};

export default MaintainCommodity;
